import styled from '@emotion/styled';

export const TableContainer = styled.div`
	width: 100%;
`;

export const Table = styled.div`
	display: grid;
	grid-template-columns: minmax(8rem, 10rem) minmax(28rem, 1fr) minmax(12rem, 10rem) minmax(8rem, 16rem);
	// grid-template-columns: minmax(8rem, 10rem) minmax(20rem, 1fr) minmax(8rem, 10rem) minmax(8rem, 10rem) minmax(12rem, 16rem);
	grid-auto-rows: minmax(52px, auto);
	max-width: 100%;
	width: 100%;
`;

export const TableHeaderCell = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 1rem 1.2rem;
	background-color: #EBF1FF;
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightBold};
	line-height: 130%;
	letter-spacing: -0.6px;
	min-width: 10rem;
  	border-top: 1.2px solid #222;
`;

export const TableCell = styled.div`
	height: 5.2rem;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 1rem 1.2rem;
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: 140%;
	letter-spacing: -0.6px;
	cursor: pointer;
	border-bottom: 1px solid rgba(173, 181, 189, 0.4);
	&.start {
		justify-content: flex-start;
	}
	span {
		padding: 0rem 0.8rem;
		border-radius: 9999px;
		background: #01337d;
		height: 2.8rem;
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 0.2rem;
		border: none;
		color: white;
		font-size: 1.4rem;
		font-weight: 700;
		line-height: normal;
		letter-spacing: -0.6px;
	}
`;
